/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * SurgicalChecklist
 * OpenAPI spec version: v1
 */
import type {
  CheckEligibilityResponseDTO,
  DeleteApiSurgicalChecklistDeleteSurgicalChecklistParams,
  DraftSurgicalChecklistPhaseRequestDTO,
  EligibilityRequestDTO,
  GetApiSurgicalChecklistGetORDisplayParams,
  GetApiSurgicalChecklistGetSurgicalChecklistDetailsParams,
  LoggedInUserInfoDTO,
  MultiMediaRequestDTO,
  MultiMediaResponseDTO,
  None,
  PostApiSurgicalChecklistCreateSurgicalChecklistParams,
  PutApiSurgicalChecklistUnsignSurgicalChecklistPhaseParams,
  SettingsDTO,
  SignSurgicalChecklistPhaseRequestDTO,
  SurgicalChecklistDTOPaginatedResponseDTO,
  SurgicalChecklistDetailResponseDTO,
  SurgicalChecklistORDisplayResponseDTO,
  SurgicalChecklistsRequestDTO,
  UserSettingDTO
} from './dtos';

import { sendRequest } from './utils/httpClient';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const postApiCHCheckEligibility = (
    eligibilityRequestDTO?: EligibilityRequestDTO,
 options?: SecondParameter<typeof sendRequest<CheckEligibilityResponseDTO | void>>,) => {
      return sendRequest<CheckEligibilityResponseDTO | void>(
      {url: `/api/CH/CheckEligibility`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eligibilityRequestDTO
    },
      options);
    }

export const postApiMultimediaRequestMultiMedia = (
    multiMediaRequestDTO?: MultiMediaRequestDTO,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Multimedia/RequestMultiMedia`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: multiMediaRequestDTO
    },
      options);
    }

export const getApiMultimediaGetOrgMultimediaByTypeOrgIdMultimediaType = (
    orgId: number,
    multimediaType: string,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Multimedia/GetOrgMultimediaByType/${orgId}/${multimediaType}`, method: 'GET'
    },
      options);
    }

export const getApiMultimediaGetOrgBannerPictureByPatientIdPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest<MultiMediaResponseDTO>>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Multimedia/GetOrgBannerPictureByPatientId/${patientId}`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetSurgicalChecklistFilterSettings = (

 options?: SecondParameter<typeof sendRequest<SettingsDTO>>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetSurgicalChecklistFilterSettings`, method: 'GET'
    },
      options);
    }

export const getApiSettingsGetOrCreateUserSettings = (

 options?: SecondParameter<typeof sendRequest<UserSettingDTO>>,) => {
      return sendRequest<UserSettingDTO>(
      {url: `/api/Settings/GetOrCreateUserSettings`, method: 'GET'
    },
      options);
    }

export const postApiSettingsCreateOrUpdateUserSettings = (
    userSettingDTO?: UserSettingDTO,
 options?: SecondParameter<typeof sendRequest<UserSettingDTO>>,) => {
      return sendRequest<UserSettingDTO>(
      {url: `/api/Settings/CreateOrUpdateUserSettings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userSettingDTO
    },
      options);
    }

export const postApiSurgicalChecklistEnsureFutureSurgeryAppointmentsHaveChecklists = (

 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/SurgicalChecklist/EnsureFutureSurgeryAppointmentsHaveChecklists`, method: 'POST'
    },
      options);
    }

export const postApiSurgicalChecklistCreateSurgicalChecklist = (
    params?: PostApiSurgicalChecklistCreateSurgicalChecklistParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/SurgicalChecklist/CreateSurgicalChecklist`, method: 'POST',
        params
    },
      options);
    }

export const postApiSurgicalChecklistGetSurgicalChecklists = (
    surgicalChecklistsRequestDTO?: SurgicalChecklistsRequestDTO,
 options?: SecondParameter<typeof sendRequest<SurgicalChecklistDTOPaginatedResponseDTO>>,) => {
      return sendRequest<SurgicalChecklistDTOPaginatedResponseDTO>(
      {url: `/api/SurgicalChecklist/GetSurgicalChecklists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: surgicalChecklistsRequestDTO
    },
      options);
    }

export const getApiSurgicalChecklistGetSurgicalChecklistDetails = (
    params?: GetApiSurgicalChecklistGetSurgicalChecklistDetailsParams,
 options?: SecondParameter<typeof sendRequest<SurgicalChecklistDetailResponseDTO>>,) => {
      return sendRequest<SurgicalChecklistDetailResponseDTO>(
      {url: `/api/SurgicalChecklist/GetSurgicalChecklistDetails`, method: 'GET',
        params
    },
      options);
    }

export const deleteApiSurgicalChecklistDeleteSurgicalChecklist = (
    params?: DeleteApiSurgicalChecklistDeleteSurgicalChecklistParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/SurgicalChecklist/DeleteSurgicalChecklist`, method: 'DELETE',
        params
    },
      options);
    }

export const putApiSurgicalChecklistDraftSurgicalChecklistPhase = (
    draftSurgicalChecklistPhaseRequestDTO?: DraftSurgicalChecklistPhaseRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/SurgicalChecklist/DraftSurgicalChecklistPhase`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: draftSurgicalChecklistPhaseRequestDTO
    },
      options);
    }

export const putApiSurgicalChecklistSignSurgicalChecklistPhase = (
    signSurgicalChecklistPhaseRequestDTO?: SignSurgicalChecklistPhaseRequestDTO,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/SurgicalChecklist/SignSurgicalChecklistPhase`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: signSurgicalChecklistPhaseRequestDTO
    },
      options);
    }

export const putApiSurgicalChecklistUnsignSurgicalChecklistPhase = (
    params?: PutApiSurgicalChecklistUnsignSurgicalChecklistPhaseParams,
 options?: SecondParameter<typeof sendRequest<None>>,) => {
      return sendRequest<None>(
      {url: `/api/SurgicalChecklist/UnsignSurgicalChecklistPhase`, method: 'PUT',
        params
    },
      options);
    }

export const getApiSurgicalChecklistGetORDisplay = (
    params?: GetApiSurgicalChecklistGetORDisplayParams,
 options?: SecondParameter<typeof sendRequest<SurgicalChecklistORDisplayResponseDTO>>,) => {
      return sendRequest<SurgicalChecklistORDisplayResponseDTO>(
      {url: `/api/SurgicalChecklist/GetORDisplay`, method: 'GET',
        params
    },
      options);
    }

export const getApiUserGetLoggedInUserInfo = (

 options?: SecondParameter<typeof sendRequest<LoggedInUserInfoDTO>>,) => {
      return sendRequest<LoggedInUserInfoDTO>(
      {url: `/api/User/GetLoggedInUserInfo`, method: 'GET'
    },
      options);
    }

export type PostApiCHCheckEligibilityResult = NonNullable<Awaited<ReturnType<typeof postApiCHCheckEligibility>>>
export type PostApiMultimediaRequestMultiMediaResult = NonNullable<Awaited<ReturnType<typeof postApiMultimediaRequestMultiMedia>>>
export type GetApiMultimediaGetOrgMultimediaByTypeOrgIdMultimediaTypeResult = NonNullable<Awaited<ReturnType<typeof getApiMultimediaGetOrgMultimediaByTypeOrgIdMultimediaType>>>
export type GetApiMultimediaGetOrgBannerPictureByPatientIdPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiMultimediaGetOrgBannerPictureByPatientIdPatientId>>>
export type GetApiSettingsGetSurgicalChecklistFilterSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetSurgicalChecklistFilterSettings>>>
export type GetApiSettingsGetOrCreateUserSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetOrCreateUserSettings>>>
export type PostApiSettingsCreateOrUpdateUserSettingsResult = NonNullable<Awaited<ReturnType<typeof postApiSettingsCreateOrUpdateUserSettings>>>
export type PostApiSurgicalChecklistEnsureFutureSurgeryAppointmentsHaveChecklistsResult = NonNullable<Awaited<ReturnType<typeof postApiSurgicalChecklistEnsureFutureSurgeryAppointmentsHaveChecklists>>>
export type PostApiSurgicalChecklistCreateSurgicalChecklistResult = NonNullable<Awaited<ReturnType<typeof postApiSurgicalChecklistCreateSurgicalChecklist>>>
export type PostApiSurgicalChecklistGetSurgicalChecklistsResult = NonNullable<Awaited<ReturnType<typeof postApiSurgicalChecklistGetSurgicalChecklists>>>
export type GetApiSurgicalChecklistGetSurgicalChecklistDetailsResult = NonNullable<Awaited<ReturnType<typeof getApiSurgicalChecklistGetSurgicalChecklistDetails>>>
export type DeleteApiSurgicalChecklistDeleteSurgicalChecklistResult = NonNullable<Awaited<ReturnType<typeof deleteApiSurgicalChecklistDeleteSurgicalChecklist>>>
export type PutApiSurgicalChecklistDraftSurgicalChecklistPhaseResult = NonNullable<Awaited<ReturnType<typeof putApiSurgicalChecklistDraftSurgicalChecklistPhase>>>
export type PutApiSurgicalChecklistSignSurgicalChecklistPhaseResult = NonNullable<Awaited<ReturnType<typeof putApiSurgicalChecklistSignSurgicalChecklistPhase>>>
export type PutApiSurgicalChecklistUnsignSurgicalChecklistPhaseResult = NonNullable<Awaited<ReturnType<typeof putApiSurgicalChecklistUnsignSurgicalChecklistPhase>>>
export type GetApiSurgicalChecklistGetORDisplayResult = NonNullable<Awaited<ReturnType<typeof getApiSurgicalChecklistGetORDisplay>>>
export type GetApiUserGetLoggedInUserInfoResult = NonNullable<Awaited<ReturnType<typeof getApiUserGetLoggedInUserInfo>>>
